export const RESET = 'TESTIMONIAL_UPDATE_RESET';
export const SET_ERROR = 'TESTIMONIAL_UPDATE_SET_ERROR';
export const SET_RETRIEVED = 'TESTIMONIAL_UPDATE_SET_RETRIEVED';
export const SET_UPDATED = 'TESTIMONIAL_UPDATE_SET_UPDATED';
export const SET_VIOLATIONS = 'TESTIMONIAL_UPDATE_SET_VIOLATIONS';
export const TOGGLE_LOADING = 'TESTIMONIAL_UPDATE_TOGGLE_LOADING';
export const UPDATE_RETRIEVED = 'TESTIMONIAL_UPDATE_UPDATE_RETRIEVED';



// WEBPACK FOOTER //
// ./src/store/modules/testimonial/update/mutation_types.js